import { render, staticRenderFns } from "./ConfigAlertMsTeams.vue?vue&type=template&id=752a5c62&"
import script from "./ConfigAlertMsTeams.vue?vue&type=script&lang=js&"
export * from "./ConfigAlertMsTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports